import React from 'react';
import BaseComponent from '../../../../baseClasses/BaseComponent/index';
import dataModel from '../../../../models/DataModel';
import './FileUploadPreview.scss';

// TODO: collapse this with other <FileUploadPreview> component.. code is 99% the same
class FileUploadPreview extends BaseComponent {
  componentDidMount() {
    // register for speech detection
    dataModel.mobileBridge.addSpeechDetectedObserver(this.handleSpeechDetected);
  }

  componentWillUnmount() {
    //unregister for speech detection
    dataModel.mobileBridge.removeSpeechDetectedObserver(this.handleSpeechDetected);
  }

  handleSpeechDetected(speechText) {
    const speechDataLowerWithoutSpaces = speechText.replace(/ /g, '').toLowerCase();

    if (
      speechDataLowerWithoutSpaces.includes('confirm') ||
      speechDataLowerWithoutSpaces.includes('keep') ||
      speechDataLowerWithoutSpaces.includes('yes')
    ) {
      this.props.handleUploadConfirm(true);
    }
    else if (
      speechDataLowerWithoutSpaces.includes('cancel') ||
      speechDataLowerWithoutSpaces.includes('no')
    ) {
      this.props.handleUploadCancel();
    }
    else {
      setTimeout(() => {
        dataModel.showGlobalModal('HANDSFREE_ERROR_MODAL', {
          message: 'Hint: try saying confirm or cancel',
        });
      }, 3000);
    }
  }
  
  handleClick(e) {
    if (e.target && e.target.getAttribute('name') && e.target.getAttribute('name') == 'upload-preview-background') {
      this.props.handleUploadCancel();
    }
  }

  render() {
    const {
      fileToPreview,
      handleUploadConfirm,
      handleUploadCancel,
    } = this.props;
    let previewUrl;

    if (fileToPreview.type == 'image' && fileToPreview.file) {
      previewUrl = URL.createObjectURL(fileToPreview.file);
    }

    const isIos = navigator.userAgent ? /(iphone)/i.test(navigator.userAgent.toLowerCase()) : false;

    return (
      <div className="upload-preview__background" name="upload-preview-background" onClick={this.handleClick}>
        <div className={'upload-preview' + (!isIos ? ' android' : '')}>
          <header className="upload-preview__header">confirm upload</header>
          {fileToPreview.file.name && (
            <div className="upload-preview__filename">
              {fileToPreview.file.name}
            </div>
          )}
          <div className="upload-preview__file">
            {fileToPreview &&
              fileToPreview.type == 'image' && (
                <img
                  className="upload-preview__image"
                  src={previewUrl}
                  alt="Library Upload Preview"
                />
              )}
          </div>
          <footer className="upload-preview__footer">
            <button
              className="upload-preview__footer__cancel"
              onClick={handleUploadCancel}
              type='button'
            >
              Cancel
            </button>
            <button
              className="upload-preview__footer__confirm"
              onClick={handleUploadConfirm}
              type='button'
            >
              Confirm
            </button>
          </footer>
        </div>
      </div>
    );
  }
}

export default FileUploadPreview;



// WEBPACK FOOTER //
// ./src/components/TaskCompletionStepsMobile/PhotoUpload/FileUploadPreview/index.js